import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Navbar from "./components/Navbar";
import HomePage from "./components/HomePage";
import CryptoDetail from "./components/CryptoDetail";
import NewsDetail from "./components/NewsDetail";
import 'bootstrap/dist/css/bootstrap.min.css'; 

function App() {
    return (
        <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID"> 
            <Router>
                <Navbar />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/crypto/:id" element={<CryptoDetail />} />
                    <Route path="/news/:id" element={<NewsDetail />} />
                </Routes>
            </Router>
        </GoogleOAuthProvider>
    );
}

export default App;

